import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, Teleport as _Teleport, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-705c9467"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href", "data-pswp-width", "data-pswp-height"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "rounded-md bg-yellow-400/80 p-4 text-center text-xs sm:text-sm text-gray-50 flex-1 m-5" }
const _hoisted_4 = {
  key: 1,
  class: "vjs-loading-spinner"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "vjs-icon-placeholder",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "vjs-control-text",
  "aria-live": "polite"
}, "Play", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vjs-live-control vjs-control" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "vjs-live-display",
    "aria-live": "off"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "vjs-control-text" }, "Stream Type "),
    /*#__PURE__*/_createTextVNode("LIVE ")
  ])
], -1))
const _hoisted_10 = ["title"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "vjs-icon-placeholder",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "vjs-control-text",
  "aria-live": "polite"
}, "Fullscreen", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[100000000]" }

import { ArrowPathIcon } from "@heroicons/vue/24/outline";
import mobile from "is-mobile";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import { onMounted, onUnmounted, PropType, ref } from "vue";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import { useCurrentCustomerName, useCurrentSiteId } from "shared/composables/project";
import { useFullWindow4to3RatioDimensionStyle } from "shared/composables/screen";
import StreamRepository from "shared/repositories/StreamRepository";
import logger from "shared/services/logger";

const refreshButtonSvg = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="size-6 mx-auto" stroke-width="2.5" stroke="#fff">
  <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
</svg>
`;
const compressButtonSvg = `<svg xmlns="http://www.w3.org/2000/svg" fill="#fff" viewBox="0 0 500 500" class="size-6">
    <path d="M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 320c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0z"/>
</svg>`;


export default /*#__PURE__*/_defineComponent({
  __name: 'OaiLiveImagePlayer',
  props: {
  cameraId: {
    type: String,
    required: true,
  },
  showControls: {
    type: Boolean,
    required: false,
    default: true,
  },
  noSrcMessage: {
    type: String as PropType<string | null>,
    required: false,
  },
  addRightSpaceToControlBar: {
    type: Boolean,
    required: false,
  },
  reloadIntervalInMs: {
    type: Number,
    required: false,
    default: 60 * 1000,
  },
},
  emits: ["lowBandWidthError"],
  setup(__props, { emit: __emit }) {

const imageUrl = ref<string | null>(null);
const loading = ref(false);
const hasError = ref(false);
const isUserActive = ref(true);
const isPlaying = ref(false);
const containerRef = ref<HTMLDivElement | null>(null);
const userActiveInitialTimer = ref<ReturnType<typeof setTimeout> | null>(null);
const refreshTimer = ref<ReturnType<typeof setInterval> | null>(null);
const abortController = ref<AbortController | null>(null);

const isMobileDevice = mobile();
const currentCustomerName = useCurrentCustomerName();
const currentSiteId = useCurrentSiteId();
const fullWindow4to3RatioDimensionStyle = useFullWindow4to3RatioDimensionStyle();

const props = __props;

const emit = __emit;

const getImageSize = () => {
  const browserWidth = window.innerWidth;
  const browserHeight = window.innerHeight;
  const ratio = 4 / 3;
  let width = browserWidth;
  let height = browserHeight;

  if (width / height > ratio) {
    width = height * ratio;
  } else {
    height = width / ratio;
  }
  return { width: width, height: height };
};

const loadLiveImage = () => {
  if (loading.value) {
    return;
  }
  loading.value = true;
  hasError.value = false;

  abortController.value = new AbortController();

  StreamRepository.loadLiveImage(
    currentCustomerName,
    currentSiteId,
    props.cameraId,
    abortController.value.signal,
  )
    .then((imageArrayBuffer) => {
      if (imageArrayBuffer) {
        if (imageUrl.value) {
          window.URL.revokeObjectURL(imageUrl.value);
        }
        const blob = new Blob([imageArrayBuffer], { type: "image/jpeg" });
        imageUrl.value = window.URL.createObjectURL(blob);

        const galleryImage = lightbox.value?.pswp?.currSlide?.content?.element as HTMLInputElement;
        if (galleryImage) {
          galleryImage.src = imageUrl.value;
        }

        startUserActiveInitialTimer();
      } else {
        hasError.value = true;
      }
    })
    .catch((error) => {
      hasError.value = true;
      logger.error(error);
    })
    .finally(() => {
      if (!imageUrl.value) {
        emit("lowBandWidthError");
      }
      loading.value = false;
    });
};

const handleImageClick = (e: MouseEvent) => {
  e.stopPropagation();
  e.preventDefault();

  if (!props.showControls) {
    return;
  }
  if (isPlaying.value) {
    stopPlay();
  } else {
    startPlay({ dontReload: true });
  }
};

const handlePlayClick = () => {
  if (isPlaying.value) {
    stopPlay();
  } else {
    startPlay();
  }
};

const handleFullScreenClick = () => {
  if (!lightbox.value) {
    return;
  }

  const pswp = lightbox.value.pswp;
  if (pswp?.isOpen) {
    pswp?.close();
  } else {
    lightbox.value?.loadAndOpen(0);
  }
};

const startUserActiveInitialTimer = () => {
  if (userActiveInitialTimer.value === null && isPlaying.value) {
    userActiveInitialTimer.value = setTimeout(() => {
      isUserActive.value = false;
    }, 3000);
  }
};

const stopUserActiveInitialTimer = () => {
  if (userActiveInitialTimer.value !== null) {
    clearTimeout(userActiveInitialTimer.value);
  }
};

const startPlay = (options?: { dontReload: boolean }) => {
  isPlaying.value = true;
  if (!options?.dontReload) {
    loadLiveImage();
  }
  refreshTimer.value = setInterval(() => {
    loadLiveImage();
  }, props.reloadIntervalInMs);
};

const stopPlay = () => {
  isPlaying.value = false;
  if (refreshTimer.value !== null) {
    clearInterval(refreshTimer.value);
  }
};

onMounted(() => {
  mountPhotoSwipe();
  if (isMobileDevice) {
    loadLiveImage();
  } else {
    startPlay();
  }
});

onUnmounted(() => {
  stopUserActiveInitialTimer();
  stopPlay();
  if (abortController.value && loading.value) {
    abortController.value.abort();
  }

  lightbox.value?.destroy();
});

const lightbox = ref<PhotoSwipeLightbox | null>(null);
const id = `gallery-${props.cameraId}`;
const mountPhotoSwipe = () => {
  if (lightbox.value) {
    return;
  }

  const lightboxInstance = new PhotoSwipeLightbox({
    gallery: `#${id}`,
    children: "a",
    pswpModule: () => import("photoswipe"),
    wheelToZoom: true,
    closeSVG: compressButtonSvg,
    zoom: false,
  });

  lightboxInstance.on("uiRegister", () => {
    lightboxInstance.pswp?.ui?.registerElement({
      name: "refresh-button",
      order: 8,
      isButton: true,
      tagName: "a",
      className: "flex items-center justify-center",
      html: refreshButtonSvg,
      onClick: loadLiveImage,
    });
  });

  lightboxInstance.init();
  lightbox.value = lightboxInstance;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: id }, [
      _createElementVNode("div", {
        class: _normalizeClass(["bg-oaiGray-900 video-js vjs-live vjs-4-3", {
        'vjs-waiting': loading.value,
        'vjs-user-active': isUserActive.value,
        'vjs-user-inactive': !isUserActive.value,
        'vjs-has-started': imageUrl.value,
        'vjs-playing': isPlaying.value,
        'vjs-paused': !isPlaying.value,
        'vjs-controls-enabled': __props.showControls,
      }]),
        onMouseenter: _cache[2] || (_cache[2] = ($event: any) => {
        stopUserActiveInitialTimer();
        isUserActive.value = true;
      }),
        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (isUserActive.value = false)),
        onMousemove: _cache[4] || (_cache[4] = ($event: any) => (isUserActive.value = true)),
        ref_key: "containerRef",
        ref: containerRef
      }, [
        _createElementVNode("a", {
          class: "image-content select-none block",
          href: imageUrl.value ? imageUrl.value : '',
          target: "_blank",
          rel: "noreferrer",
          "data-pswp-width": getImageSize().width,
          "data-pswp-height": getImageSize().height
        }, [
          (imageUrl.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: imageUrl.value,
                alt: "live image",
                class: "h-full",
                onDblclick: handleFullScreenClick,
                onClick: handleImageClick
              }, null, 40, _hoisted_2))
            : _createCommentVNode("", true)
        ], 8, _hoisted_1),
        (hasError.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "error-content",
              style: _normalizeStyle(`${_unref(fullWindow4to3RatioDimensionStyle)}; height: auto;`)
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(__props.noSrcMessage || _ctx.$t("video_player.unable_to_play_message")), 1)
            ], 4))
          : _createCommentVNode("", true),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4))
          : _createCommentVNode("", true),
        (__props.showControls)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["vjs-control-bar", { 'pr-5': __props.addRightSpaceToControlBar }]),
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["vjs-play-control vjs-control vjs-button", {
            'vjs-playing': isPlaying.value,
            'vjs-paused': !isPlaying.value,
          }]),
                type: "button",
                title: isPlaying.value ? 'Pause' : 'Play',
                "aria-disabled": "false",
                onClick: handlePlayClick
              }, _hoisted_8, 10, _hoisted_5),
              _hoisted_9,
              _createElementVNode("div", {
                class: "flex items-center cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (loadLiveImage()))
              }, [
                _createVNode(_unref(ArrowPathIcon), { class: "w-4 h-4 text-white" })
              ]),
              _createElementVNode("button", {
                class: "vjs-fullscreen-control vjs-control vjs-button",
                type: "button",
                title: lightbox.value?.pswp?.isOpen ? 'Non-Fullscreen' : 'Fullscreen',
                "aria-disabled": "false",
                onClick: handleFullScreenClick
              }, _hoisted_13, 8, _hoisted_10)
            ], 2))
          : _createCommentVNode("", true)
      ], 34)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#loading-spinner" }, [
      _createElementVNode("div", _hoisted_14, [
        (loading.value && lightbox.value?.pswp?.isOpen)
          ? (_openBlock(), _createBlock(LoadingSpinner, {
              key: 0,
              color: "text-white"
            }))
          : _createCommentVNode("", true)
      ])
    ]))
  ], 64))
}
}

})